export function eventOriginIsCapacitor(event: MessageEvent) {
    const allowedOrigins = [
        'capacitor://localhost',
        'http://localhost',
        'https://localhost'
    ]

    // Block anything that isn't a native Capacitor app
    return allowedOrigins.includes(event.origin)
}
